module.exports = __webpack_public_path__ + "static/bank-CCF.15c770e3.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/bank-CCF.png
// module id = 973
// module chunks = 2